import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import { ChevronRight } from 'lucide-vue-next';

    interface Props {
        disabled?: boolean;
        loading?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ContinueButton',
  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "continue",
    size: "xs",
    disabled: _ctx.disabled || _ctx.loading,
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(_unref(ChevronRight))
    ]),
    _: 3
  }, 8, ["disabled", "loading"]))
}
}

})